import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';

const AiSecurityGovernanceTechStack = () => {
    return (
        <div className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
        style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="AI Security & Threat Defense">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-HiddenLayer.svg"
                                            className="img-fluid mb-2.5"
                                            alt="HiddenLayer"
                                            title="HiddenLayer"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">HiddenLayer</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-protect-ai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Protect AI"
                                            title="Protect AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Protect AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-robust-intelligence.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Robust Intelligence"
                                            title="Robust Intelligence"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Robust Intelligence</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-calypsoai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CalypsoAI"
                                            title="CalypsoAI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">CalypsoAI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-lakera-guard.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Lakera Guard"
                                            title="Lakera Guard"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Lakera Guard</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-adversa-ai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Adversa AI"
                                            title="Adversa AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Adversa AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-prompt-security.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Prompt Security"
                                            title="Prompt Security"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Prompt Security</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-rebuff.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Rebuff"
                                            title="Rebuff"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Rebuff</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-llm-guard.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LLM Guard"
                                            title="LLM Guard"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LLM Guard</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-nemo-guardrails.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NeMo Guardrails"
                                            title="NeMo Guardrails"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">NeMo Guardrails</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-azure.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Content Safety"
                                            title="Azure Content Safety"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Content Safety</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Privacy & Encryption">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-hashicorp-vault.svg"
                                            className="img-fluid mb-2.5"
                                            alt="HashiCorp Vault"
                                            title="HashiCorp Vault"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">HashiCorp Vault</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-aws-kms.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="AWS KMS"
                                            title="AWS KMS"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS KMS</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-azure-Key-vault.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure Key Vault"
                                            title="Azure Key Vault"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Key Vault</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-google-cloud-kms.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google Cloud KMS"
                                            title="Google Cloud KMS"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Cloud KMS</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-confidential-computing.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Confidential Computing"
                                            title="Confidential Computing"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Confidential Computing</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-homomorphic-encryption.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Homomorphic Encryption"
                                            title="Homomorphic Encryption"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Homomorphic Encryption</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Access Control & Identity">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-platforms/ic-Okta.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Okta"
                                            title="Okta"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Okta</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_azure.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure AD"
                                            title="Azure AD"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure AD</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/python/svg/ic-aws.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS IAM"
                                            title="AWS IAM"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS IAM</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-platforms/ic-Auth0.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Auth0"
                                            title="Auth0"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Auth0</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-keycloak.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Keycloak"
                                            title="Keycloak"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Keycloak</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/sso.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OAuth"
                                            title="OAuth"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OAuth</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-saml.svg"
                                            className="img-fluid mb-2.5"
                                            alt="SAML"
                                            title="SAML"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">SAML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-rbac.svg"
                                            className="img-fluid mb-2.5"
                                            alt="RBAC"
                                            title="RBAC"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">RBAC</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Monitoring, Compliance & Governance">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-platforms/ic-datadog.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Datadog"
                                            title="Datadog"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Datadog</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-security.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Security"
                                            title="Security"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Security</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-platforms/ic-Splunk.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Splunk"
                                            title="Splunk"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Splunk</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-ibm.svg"
                                            className="img-fluid mb-2.5"
                                            alt="IBM OpenPages"
                                            title="IBM OpenPages"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">IBM OpenPages</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-onetrust.svg"
                                            className="img-fluid mb-2.5 !w-24"
                                            alt="OneTrust"
                                            title="OneTrust"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OneTrust</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-trustarc.svg"
                                            className="img-fluid mb-2.5 !w-24"
                                            alt="TrustArc"
                                            title="TrustArc"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">TrustArc</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-collibra.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Collibra"
                                            title="Collibra"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Collibra</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/data-engineering-foundations/ic-apache-atlas.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Apache Atlas"
                                            title="Apache Atlas"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Apache Atlas</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Model Monitoring & Explainability">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Fiddler-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Fiddler AI"
                                            title="Fiddler AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Fiddler AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-arthur.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Arthur AI"
                                            title="Arthur AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Arthur AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-arize.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Arize AI"
                                            title="Arize AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Arize AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-whylabs.svg"
                                            className="img-fluid mb-2.5"
                                            alt="WhyLabs"
                                            title="WhyLabs"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">WhyLabs</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/machine-learning/ic-Evidently-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Evidently AI"
                                            title="Evidently AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Evidently AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-fairlearn.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Fairlearn"
                                            title="Fairlearn"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Fairlearn</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-ai-fairness.svg"
                                            className="img-fluid mb-2.5"
                                            alt="IBM Fairness 360"
                                            title="IBM Fairness 360"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">IBM Fairness 360</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-shap.svg"
                                            className="img-fluid mb-2.5"
                                            alt="SHAP"
                                            title="SHAP"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">SHAP</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-interpretml.svg"
                                            className="img-fluid mb-2.5"
                                            alt="InterpretML"
                                            title="InterpretML"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">InterpretML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/vision-and-multimodal-ai/svg/ic-mlflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MLflow Registry"
                                            title="MLflow Registry"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">MLflow Registry</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Vulnerability Scanning">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-snyk.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Snyk"
                                            title="Snyk"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Snyk</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-aqua.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Aqua Security"
                                            title="Aqua Security"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Aqua Security</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-trivy.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Trivy"
                                            title="Trivy"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Trivy</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-owasp.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OWASP Dependency"
                                            title="OWASP Dependency"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OWASP Dependency</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-security/ic-bandit.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Bandit"
                                            title="Bandit"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Bandit</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AiSecurityGovernanceTechStack;
